import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Button, Divider, TimePicker, Checkbox, Tooltip, message } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { getRestaurant, getIsSavingRestaurant, getIsSavedRestaurant } from '../../reducers';
import { setDefaultTimetableToRestaurant, setSavedRestaurant } from '../../actions/setDefaultTimetableToRestaurant';

class FormBusinessDaysResto extends Component {
    state = {
        isDobleTimeMonday: false, isDobleTimeTuesday: false, isDobleTimeWednesday: false, isDobleTimeThursday: false, isDobleTimeFriday: false, isDobleTimeSaturday: false, isDobleTimeSunday: false,
    }

    componentDidMount() {
        const { restaurant } = this.props;
        var isDobleTimeMonday = false
        var isDobleTimeTuesday = false
        var isDobleTimeWednesday = false
        var isDobleTimeThursday = false
        var isDobleTimeFriday = false
        var isDobleTimeSaturday = false
        var isDobleTimeSunday = false
        if(restaurant.timetable && restaurant.timetable.default) {
            isDobleTimeMonday = (restaurant.timetable.default.monday && restaurant.timetable.default.monday[1] && restaurant.timetable.default.monday[1].open && restaurant.timetable.default.monday[1].open !== "-")
            isDobleTimeTuesday = (restaurant.timetable.default.tuesday && restaurant.timetable.default.tuesday[1] && restaurant.timetable.default.tuesday[1].open && restaurant.timetable.default.tuesday[1].open !== "-")
            isDobleTimeWednesday = (restaurant.timetable.default.wednesday && restaurant.timetable.default.wednesday[1] && restaurant.timetable.default.wednesday[1].open && restaurant.timetable.default.wednesday[1].open !== "-")
            isDobleTimeThursday = (restaurant.timetable.default.thursday && restaurant.timetable.default.thursday[1] && restaurant.timetable.default.thursday[1].open && restaurant.timetable.default.thursday[1].open !== "-")
            isDobleTimeFriday = (restaurant.timetable.default.friday && restaurant.timetable.default.friday[1] && restaurant.timetable.default.friday[1].open && restaurant.timetable.default.friday[1].open !== "-")
            isDobleTimeSaturday = (restaurant.timetable.default.saturday && restaurant.timetable.default.saturday[1] && restaurant.timetable.default.saturday[1].open && restaurant.timetable.default.saturday[1].open !== "-")
            isDobleTimeSunday = (restaurant.timetable.default.sunday && restaurant.timetable.default.sunday[1] && restaurant.timetable.default.sunday[1].open && restaurant.timetable.default.sunday[1].open !== "-")
        }
        this.setState(function(prevState, props) {
            return { isDobleTimeMonday, isDobleTimeTuesday, isDobleTimeWednesday, isDobleTimeThursday, isDobleTimeFriday, isDobleTimeSaturday, isDobleTimeSunday }
        })
    }
    

    onSubmit = values => {
        var isError = false;
        var defaultHours = { 'monday': [], 'tuesday': [], 'wednesday': [], 'thursday': [], 'friday': [], 'saturday': [], 'sunday': [] };
        //Monday
        if(values.field_monday_open || values.field_monday_close) {
            if(values.field_monday_open && values.field_monday_close) {
                console.log("lunes!");
                console.log(moment(values.field_monday_open).format("HH:mm"));
                console.log(moment(values.field_monday_close).format("HH:mm"));
                defaultHours['monday'][0] = { 
                    open: moment(values.field_monday_open).format("HH:mm"),
                    close: moment(values.field_monday_close).format("HH:mm"),
                };
            } else {
                //error
                isError = true;
                message.error('Complete los campos del día lunes o destilde el doble turno.');
                console.log("error lunes!");
            }
        } else {
            //primer hora con -
            defaultHours['monday'][0] = { 
                open: "-",
                close: "-",
            };
        }
        if(values.field_check_dobletime_monday) {
            if(values.field_monday_open && values.field_monday_close) {
                if(values.field_monday_dobletime_open && values.field_monday_dobletime_close) {
                    //marcha segunda hora
                    defaultHours['monday'][1] = {
                        open: moment(values.field_monday_dobletime_open).format("HH:mm"),
                        close: moment(values.field_monday_dobletime_close).format("HH:mm"),
                    };
                } else {
                    //error segundos incompletos
                    message.error('Complete los campos del día lunes o destilde el doble turno.');
                    isError = true;
                }
            } else {
                //error primeros incompletos
                message.error('Complete los campos del día lunes o destilde el doble turno.');
                isError = true;
            }
        } else {
            //segunda hora con -
            defaultHours['monday'][1] = { 
                open: "-",
                close: "-",
            };
        }
        //Tuesday
        if(values.field_tuesday_open || values.field_tuesday_close) {
            if(values.field_tuesday_open && values.field_tuesday_close) {
                console.log("martes!");
                defaultHours['tuesday'][0] = { 
                    open: moment(values.field_tuesday_open).format("HH:mm"),
                    close: moment(values.field_tuesday_close).format("HH:mm"),
                };
            } else {
                //error
                isError = true;
                message.error('Complete los campos del día martes o destilde el doble turno.');
                console.log("error martes!");
            }
        } else {
            //primer hora con -
            defaultHours['tuesday'][0] = { 
                open: "-",
                close: "-",
            };
        }
        if(values.field_check_dobletime_tuesday) {
            if(values.field_tuesday_open && values.field_tuesday_close) {
                if(values.field_tuesday_dobletime_open && values.field_tuesday_dobletime_close) {
                    //marcha segunda hora
                    defaultHours['tuesday'][1] = {
                        open: moment(values.field_tuesday_dobletime_open).format("HH:mm"),
                        close: moment(values.field_tuesday_dobletime_close).format("HH:mm"),
                    };
                } else {
                    //error segundos incompletos
                    message.error('Complete los campos del día martes o destilde el doble turno.');
                    isError = true;
                }
            } else {
                //error primeros incompletos
                message.error('Complete los campos del día martes o destilde el doble turno.');
                isError = true;
            }
        } else {
            //segunda hora con -
            defaultHours['tuesday'][1] = { 
                open: "-",
                close: "-",
            };
        }
        //Wednesday
        if(values.field_wednesday_open || values.field_wednesday_close) {
            if(values.field_wednesday_open && values.field_wednesday_close) {
                console.log("miércoles!");
                defaultHours['wednesday'][0] = { 
                    open: moment(values.field_wednesday_open).format("HH:mm"),
                    close: moment(values.field_wednesday_close).format("HH:mm"),
                };
            } else {
                //error
                isError = true;
                message.error('Complete los campos del día miércoles o destilde el doble turno.');
                console.log("error miércoles!");
            }
        } else {
            //primer hora con -
            defaultHours['wednesday'][0] = { 
                open: "-",
                close: "-",
            };
        }
        if(values.field_check_dobletime_wednesday) {
            if(values.field_wednesday_open && values.field_wednesday_close) {
                if(values.field_wednesday_dobletime_open && values.field_wednesday_dobletime_close) {
                    //marcha segunda hora
                    defaultHours['wednesday'][1] = {
                        open: moment(values.field_wednesday_dobletime_open).format("HH:mm"),
                        close: moment(values.field_wednesday_dobletime_close).format("HH:mm"),
                    };
                } else {
                    //error segundos incompletos
                    message.error('Complete los campos del día miércoles o destilde el doble turno.');
                    isError = true;
                }
            } else {
                //error primeros incompletos
                message.error('Complete los campos del día miércoles o destilde el doble turno.');
                isError = true;
            }
        } else {
            //segunda hora con -
            defaultHours['wednesday'][1] = { 
                open: "-",
                close: "-",
            };
        }
        //Thursday
        if(values.field_thursday_open || values.field_thursday_close) {
            if(values.field_thursday_open && values.field_thursday_close) {
                console.log("jueves!");
                defaultHours['thursday'][0] = { 
                    open: moment(values.field_thursday_open).format("HH:mm"),
                    close: moment(values.field_thursday_close).format("HH:mm"),
                };
            } else {
                //error
                isError = true;
                message.error('Complete los campos del día jueves o destilde el doble turno.');
                console.log("error jueves!");
            }
        } else {
            //primer hora con -
            defaultHours['thursday'][0] = { 
                open: "-",
                close: "-",
            };
        }
        if(values.field_check_dobletime_thursday) {
            if(values.field_thursday_open && values.field_thursday_close) {
                if(values.field_thursday_dobletime_open && values.field_thursday_dobletime_close) {
                    //marcha segunda hora
                    defaultHours['thursday'][1] = {
                        open: moment(values.field_thursday_dobletime_open).format("HH:mm"),
                        close: moment(values.field_thursday_dobletime_close).format("HH:mm"),
                    };
                } else {
                    //error segundos incompletos
                    message.error('Complete los campos del día jueves o destilde el doble turno.');
                    isError = true;
                }
            } else {
                //error primeros incompletos
                message.error('Complete los campos del día jueves o destilde el doble turno.');
                isError = true;
            }
        } else {
            //segunda hora con -
            defaultHours['thursday'][1] = { 
                open: "-",
                close: "-",
            };
        }
        //Friday
        if(values.field_friday_open || values.field_friday_close) {
            if(values.field_friday_open && values.field_friday_close) {
                console.log("viernes!");
                defaultHours['friday'][0] = { 
                    open: moment(values.field_friday_open).format("HH:mm"),
                    close: moment(values.field_friday_close).format("HH:mm"),
                };
            } else {
                //error
                isError = true;
                message.error('Complete los campos del día viernes o destilde el doble turno.');
                console.log("error viernes!");
            }
        } else {
            //primer hora con -
            defaultHours['friday'][0] = { 
                open: "-",
                close: "-",
            };
        }
        if(values.field_check_dobletime_friday) {
            if(values.field_friday_open && values.field_friday_close) {
                if(values.field_friday_dobletime_open && values.field_friday_dobletime_close) {
                    //marcha segunda hora
                    defaultHours['friday'][1] = {
                        open: moment(values.field_friday_dobletime_open).format("HH:mm"),
                        close: moment(values.field_friday_dobletime_close).format("HH:mm"),
                    };
                } else {
                    //error segundos incompletos
                    message.error('Complete los campos del día viernes o destilde el doble turno.');
                    isError = true;
                }
            } else {
                //error primeros incompletos
                message.error('Complete los campos del día viernes o destilde el doble turno.');
                isError = true;
            }
        } else {
            //segunda hora con -
            defaultHours['friday'][1] = { 
                open: "-",
                close: "-",
            };
        }
        //Saturday
        if(values.field_saturday_open || values.field_saturday_close) {
            if(values.field_saturday_open && values.field_saturday_close) {
                console.log("sábado!");
                defaultHours['saturday'][0] = { 
                    open: moment(values.field_saturday_open).format("HH:mm"),
                    close: moment(values.field_saturday_close).format("HH:mm"),
                };
            } else {
                //error
                isError = true;
                message.error('Complete los campos del día sábado o destilde el doble turno.');
                console.log("error sábado!");
            }
        } else {
            //primer hora con -
            defaultHours['saturday'][0] = { 
                open: "-",
                close: "-",
            };
        }
        if(values.field_check_dobletime_saturday) {
            if(values.field_saturday_open && values.field_saturday_close) {
                if(values.field_saturday_dobletime_open && values.field_saturday_dobletime_close) {
                    //marcha segunda hora
                    defaultHours['saturday'][1] = {
                        open: moment(values.field_saturday_dobletime_open).format("HH:mm"),
                        close: moment(values.field_saturday_dobletime_close).format("HH:mm"),
                    };
                } else {
                    //error segundos incompletos
                    message.error('Complete los campos del día sábado o destilde el doble turno.');
                    isError = true;
                }
            } else {
                //error primeros incompletos
                message.error('Complete los campos del día sábado o destilde el doble turno.');
                isError = true;
            }
        } else {
            //segunda hora con -
            defaultHours['saturday'][1] = { 
                open: "-",
                close: "-",
            };
        }
        //Sunday
        if(values.field_sunday_open || values.field_sunday_close) {
            if(values.field_sunday_open && values.field_sunday_close) {
                console.log("domingo!");
                defaultHours['sunday'][0] = { 
                    open: moment(values.field_sunday_open).format("HH:mm"),
                    close: moment(values.field_sunday_close).format("HH:mm"),
                };
            } else {
                //error
                isError = true;
                message.error('Complete los campos del día domingo o destilde el doble turno.');
                console.log("error domingo!");
            }
        } else {
            //primer hora con -
            defaultHours['sunday'][0] = { 
                open: "-",
                close: "-",
            };
        }
        if(values.field_check_dobletime_sunday) {
            if(values.field_sunday_open && values.field_sunday_close) {
                if(values.field_sunday_dobletime_open && values.field_sunday_dobletime_close) {
                    //marcha segunda hora
                    defaultHours['sunday'][1] = {
                        open: moment(values.field_sunday_dobletime_open).format("HH:mm"),
                        close: moment(values.field_sunday_dobletime_close).format("HH:mm"),
                    };
                } else {
                    //error segundos incompletos
                    message.error('Complete los campos del día domingo o destilde el doble turno.');
                    isError = true;
                }
            } else {
                //error primeros incompletos
                message.error('Complete los campos del día domingo o destilde el doble turno.');
                isError = true;
            }
        } else {
            //segunda hora con -
            defaultHours['sunday'][1] = { 
                open: "-",
                close: "-",
            };
        }

        console.log(values);
        if(!isError) {
            /*const hide = message.loading('Guardando..', 0);
            // Dismiss manually and asynchronously
            setTimeout(hide, 1500);*/
            this.saveData(defaultHours);
        }
    }
    
    saveData = (defaultHours) => {
        const { restaurant } = this.props;
        
        this.props.setDefaultTimetableToRestaurant({
            id: restaurant.id,
            defaultHours: defaultHours,
        });
    }

    renderSavedRestaurant = () => {
        message.success('¡Los cambios se guardaron exitósamente!');
        var isSavedRestaurant = false;
        this.props.setSavedRestaurant(isSavedRestaurant);
        return;
    }

    render() {
        const { restaurant, isSavedRestaurant } = this.props;
        return (
            <Grid>
                <Form onFinish={this.onSubmit} initialValues={{
                    field_check_dobletime_monday: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.monday && restaurant.timetable.default.monday[1] && restaurant.timetable.default.monday[1].open && restaurant.timetable.default.monday[1].open !== "-"),
                    field_monday_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.monday && restaurant.timetable.default.monday[0] && restaurant.timetable.default.monday[0].open && restaurant.timetable.default.monday[0].open !== "-") ? moment(`${restaurant.timetable.default.monday[0].open}`, 'HH:mm') : null,
                    field_monday_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.monday && restaurant.timetable.default.monday[0] && restaurant.timetable.default.monday[0].close && restaurant.timetable.default.monday[0].close !== "-") ? moment(`${restaurant.timetable.default.monday[0].close}`, 'HH:mm') : null,
                    field_monday_dobletime_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.monday && restaurant.timetable.default.monday[1] && restaurant.timetable.default.monday[1].open && restaurant.timetable.default.monday[1].open !== "-") ? moment(`${restaurant.timetable.default.monday[1].open}`, 'HH:mm') : null,
                    field_monday_dobletime_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.monday && restaurant.timetable.default.monday[1] && restaurant.timetable.default.monday[1].close && restaurant.timetable.default.monday[1].close !== "-") ? moment(`${restaurant.timetable.default.monday[1].close}`, 'HH:mm') : null,
                    field_check_dobletime_tuesday: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.tuesday && restaurant.timetable.default.tuesday[1] && restaurant.timetable.default.tuesday[1].open && restaurant.timetable.default.tuesday[1].open !== "-"),
                    field_tuesday_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.tuesday && restaurant.timetable.default.tuesday[0] && restaurant.timetable.default.tuesday[0].open && restaurant.timetable.default.tuesday[0].open !== "-") ? moment(`${restaurant.timetable.default.tuesday[0].open}`, 'HH:mm') : null,
                    field_tuesday_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.tuesday && restaurant.timetable.default.tuesday[0] && restaurant.timetable.default.tuesday[0].close && restaurant.timetable.default.tuesday[0].close !== "-") ? moment(`${restaurant.timetable.default.tuesday[0].close}`, 'HH:mm') : null,
                    field_tuesday_dobletime_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.tuesday && restaurant.timetable.default.tuesday[1] && restaurant.timetable.default.tuesday[1].open && restaurant.timetable.default.tuesday[1].open !== "-") ? moment(`${restaurant.timetable.default.tuesday[1].open}`, 'HH:mm') : null,
                    field_tuesday_dobletime_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.tuesday && restaurant.timetable.default.tuesday[1] && restaurant.timetable.default.tuesday[1].close && restaurant.timetable.default.tuesday[1].close !== "-") ? moment(`${restaurant.timetable.default.tuesday[1].close}`, 'HH:mm') : null,
                    field_check_dobletime_wednesday: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.wednesday && restaurant.timetable.default.wednesday[1] && restaurant.timetable.default.wednesday[1].open && restaurant.timetable.default.wednesday[1].open !== "-"),
                    field_wednesday_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.wednesday && restaurant.timetable.default.wednesday[0] && restaurant.timetable.default.wednesday[0].open && restaurant.timetable.default.wednesday[0].open !== "-") ? moment(`${restaurant.timetable.default.wednesday[0].open}`, 'HH:mm') : null,
                    field_wednesday_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.wednesday && restaurant.timetable.default.wednesday[0] && restaurant.timetable.default.wednesday[0].close && restaurant.timetable.default.wednesday[0].close !== "-") ? moment(`${restaurant.timetable.default.wednesday[0].close}`, 'HH:mm') : null,
                    field_wednesday_dobletime_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.wednesday && restaurant.timetable.default.wednesday[1] && restaurant.timetable.default.wednesday[1].open && restaurant.timetable.default.wednesday[1].open !== "-") ? moment(`${restaurant.timetable.default.wednesday[1].open}`, 'HH:mm') : null,
                    field_wednesday_dobletime_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.wednesday && restaurant.timetable.default.wednesday[1] && restaurant.timetable.default.wednesday[1].close && restaurant.timetable.default.wednesday[1].close !== "-") ? moment(`${restaurant.timetable.default.wednesday[1].close}`, 'HH:mm') : null,
                    field_check_dobletime_thursday: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.thursday && restaurant.timetable.default.thursday[1] && restaurant.timetable.default.thursday[1].open && restaurant.timetable.default.thursday[1].open !== "-"),
                    field_thursday_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.thursday && restaurant.timetable.default.thursday[0] && restaurant.timetable.default.thursday[0].open && restaurant.timetable.default.thursday[0].open !== "-") ? moment(`${restaurant.timetable.default.thursday[0].open}`, 'HH:mm') : null,
                    field_thursday_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.thursday && restaurant.timetable.default.thursday[0] && restaurant.timetable.default.thursday[0].close && restaurant.timetable.default.thursday[0].close !== "-") ? moment(`${restaurant.timetable.default.thursday[0].close}`, 'HH:mm') : null,
                    field_thursday_dobletime_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.thursday && restaurant.timetable.default.thursday[1] && restaurant.timetable.default.thursday[1].open && restaurant.timetable.default.thursday[1].open !== "-") ? moment(`${restaurant.timetable.default.thursday[1].open}`, 'HH:mm') : null,
                    field_thursday_dobletime_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.thursday && restaurant.timetable.default.thursday[1] && restaurant.timetable.default.thursday[1].close && restaurant.timetable.default.thursday[1].close !== "-") ? moment(`${restaurant.timetable.default.thursday[1].close}`, 'HH:mm') : null,
                    field_check_dobletime_friday: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.friday && restaurant.timetable.default.friday[1] && restaurant.timetable.default.friday[1].open && restaurant.timetable.default.friday[1].open !== "-"),
                    field_friday_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.friday && restaurant.timetable.default.friday[0] && restaurant.timetable.default.friday[0].open && restaurant.timetable.default.friday[0].open !== "-") ? moment(`${restaurant.timetable.default.friday[0].open}`, 'HH:mm') : null,
                    field_friday_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.friday && restaurant.timetable.default.friday[0] && restaurant.timetable.default.friday[0].close && restaurant.timetable.default.friday[0].close !== "-") ? moment(`${restaurant.timetable.default.friday[0].close}`, 'HH:mm') : null,
                    field_friday_dobletime_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.friday && restaurant.timetable.default.friday[1] && restaurant.timetable.default.friday[1].open && restaurant.timetable.default.friday[1].open !== "-") ? moment(`${restaurant.timetable.default.friday[1].open}`, 'HH:mm') : null,
                    field_friday_dobletime_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.friday && restaurant.timetable.default.friday[1] && restaurant.timetable.default.friday[1].close && restaurant.timetable.default.friday[1].close !== "-") ? moment(`${restaurant.timetable.default.friday[1].close}`, 'HH:mm') : null,
                    field_check_dobletime_saturday: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.saturday && restaurant.timetable.default.saturday[1] && restaurant.timetable.default.saturday[1].open && restaurant.timetable.default.saturday[1].open !== "-"),
                    field_saturday_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.saturday && restaurant.timetable.default.saturday[0] && restaurant.timetable.default.saturday[0].open && restaurant.timetable.default.saturday[0].open !== "-") ? moment(`${restaurant.timetable.default.saturday[0].open}`, 'HH:mm') : null,
                    field_saturday_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.saturday && restaurant.timetable.default.saturday[0] && restaurant.timetable.default.saturday[0].close && restaurant.timetable.default.saturday[0].close !== "-") ? moment(`${restaurant.timetable.default.saturday[0].close}`, 'HH:mm') : null,
                    field_saturday_dobletime_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.saturday && restaurant.timetable.default.saturday[1] && restaurant.timetable.default.saturday[1].open && restaurant.timetable.default.saturday[1].open !== "-") ? moment(`${restaurant.timetable.default.saturday[1].open}`, 'HH:mm') : null,
                    field_saturday_dobletime_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.saturday && restaurant.timetable.default.saturday[1] && restaurant.timetable.default.saturday[1].close && restaurant.timetable.default.saturday[1].close !== "-") ? moment(`${restaurant.timetable.default.saturday[1].close}`, 'HH:mm') : null,
                    field_check_dobletime_sunday: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.sunday && restaurant.timetable.default.sunday[1] && restaurant.timetable.default.sunday[1].open && restaurant.timetable.default.sunday[1].open !== "-"),
                    field_sunday_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.sunday && restaurant.timetable.default.sunday[0] && restaurant.timetable.default.sunday[0].open && restaurant.timetable.default.sunday[0].open !== "-") ? moment(`${restaurant.timetable.default.sunday[0].open}`, 'HH:mm') : null,
                    field_sunday_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.sunday && restaurant.timetable.default.sunday[0] && restaurant.timetable.default.sunday[0].close && restaurant.timetable.default.sunday[0].close !== "-") ? moment(`${restaurant.timetable.default.sunday[0].close}`, 'HH:mm') : null,
                    field_sunday_dobletime_open: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.sunday && restaurant.timetable.default.sunday[1] && restaurant.timetable.default.sunday[1].open && restaurant.timetable.default.sunday[1].open !== "-") ? moment(`${restaurant.timetable.default.sunday[1].open}`, 'HH:mm') : null,
                    field_sunday_dobletime_close: (restaurant.timetable && restaurant.timetable.default && restaurant.timetable.default.sunday && restaurant.timetable.default.sunday[1] && restaurant.timetable.default.sunday[1].close && restaurant.timetable.default.sunday[1].close !== "-") ? moment(`${restaurant.timetable.default.sunday[1].close}`, 'HH:mm') : null
                }}>
                    <Divider orientation="left">Lunes &nbsp; &nbsp; <Tooltip title="La hora '00' representa el final del día (24h)"><QuestionCircleOutlined /></Tooltip></Divider>
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item name="field_check_dobletime_monday" rules={[{ required: false }]} valuePropName="checked">
                                <Checkbox onChange={(value) =>{ this.setState({isDobleTimeMonday: value.target.checked}) }}>Doble horario</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="md">
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_monday_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_monday_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_monday_dobletime_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"} disabled={!this.state.isDobleTimeMonday} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_monday_dobletime_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"} disabled={!this.state.isDobleTimeMonday}/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider orientation="left">Martes &nbsp; &nbsp; <Tooltip title="La hora '00' representa el final del día (24h)"><QuestionCircleOutlined /></Tooltip></Divider>
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item name="field_check_dobletime_tuesday" rules={[{ required: false }]} valuePropName="checked">
                                <Checkbox onChange={(value) =>{ this.setState({isDobleTimeTuesday: value.target.checked}) }}>Doble horario</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="md">
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_tuesday_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_tuesday_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_tuesday_dobletime_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"} disabled={!this.state.isDobleTimeTuesday} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_tuesday_dobletime_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"} disabled={!this.state.isDobleTimeTuesday}/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider orientation="left">Miércoles &nbsp; &nbsp; <Tooltip title="La hora '00' representa el final del día (24h)"><QuestionCircleOutlined /></Tooltip></Divider>
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item name="field_check_dobletime_wednesday" rules={[{ required: false }]} valuePropName="checked">
                                <Checkbox onChange={(value) =>{ this.setState({isDobleTimeWednesday: value.target.checked}) }}>Doble horario</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="md">
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_wednesday_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_wednesday_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_wednesday_dobletime_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"} disabled={!this.state.isDobleTimeWednesday} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_wednesday_dobletime_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"} disabled={!this.state.isDobleTimeWednesday}/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider orientation="left">Jueves &nbsp; &nbsp; <Tooltip title="La hora '00' representa el final del día (24h)"><QuestionCircleOutlined /></Tooltip></Divider>
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item name="field_check_dobletime_thursday" rules={[{ required: false }]} valuePropName="checked">
                                <Checkbox onChange={(value) =>{ this.setState({isDobleTimeThursday: value.target.checked}) }}>Doble horario</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="md">
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_thursday_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_thursday_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_thursday_dobletime_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"} disabled={!this.state.isDobleTimeThursday} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_thursday_dobletime_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"} disabled={!this.state.isDobleTimeThursday}/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider orientation="left">Viernes &nbsp; &nbsp; <Tooltip title="La hora '00' representa el final del día (24h)"><QuestionCircleOutlined /></Tooltip></Divider>
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item name="field_check_dobletime_friday" rules={[{ required: false }]} valuePropName="checked">
                                <Checkbox onChange={(value) =>{ this.setState({isDobleTimeFriday: value.target.checked}) }}>Doble horario</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="md">
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_friday_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_friday_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_friday_dobletime_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"} disabled={!this.state.isDobleTimeFriday} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_friday_dobletime_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"} disabled={!this.state.isDobleTimeFriday}/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider orientation="left">Sábado &nbsp; &nbsp; <Tooltip title="La hora '00' representa el final del día (24h)"><QuestionCircleOutlined /></Tooltip></Divider>
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item name="field_check_dobletime_saturday" rules={[{ required: false }]} valuePropName="checked">
                                <Checkbox onChange={(value) =>{ this.setState({isDobleTimeSaturday: value.target.checked}) }}>Doble horario</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="md">
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_saturday_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_saturday_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_saturday_dobletime_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"} disabled={!this.state.isDobleTimeSaturday} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_saturday_dobletime_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"} disabled={!this.state.isDobleTimeSaturday}/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider orientation="left">Domingo &nbsp; &nbsp; <Tooltip title="La hora '00' representa el final del día (24h)"><QuestionCircleOutlined /></Tooltip></Divider>
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item name="field_check_dobletime_sunday" rules={[{ required: false }]} valuePropName="checked">
                                <Checkbox onChange={(value) =>{ this.setState({isDobleTimeSunday: value.target.checked}) }}>Doble horario</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="md">
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_sunday_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_sunday_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_sunday_dobletime_open" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [0, 1, 2, 3, 4, 5]} defaultOpenValue={moment('06:00', 'hh:mm')} placeholder={"Inicio"} disabled={!this.state.isDobleTimeSunday} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Item name="field_sunday_dobletime_close" rules={[{ required: false }]}>
                                <TimePicker format={'HH:mm'} minuteStep={30} disabledHours={() => [1, 2, 3, 4, 5]} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [30] }}} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"} disabled={!this.state.isDobleTimeSunday}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider />
                    <Row center="xs">
                        <Col xs={12}>
                            <Form.Item>
                                {
                                    this.props.isSaving ?
                                        <Button type="primary" htmlType="submit" disabled={true} loading>
                                            Guardando
                                        </Button>
                                        :
                                        <Button type="primary" htmlType="submit">
                                            Guardar
                                        </Button>
                                }
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                {
                                isSavedRestaurant && this.renderSavedRestaurant()
                }
            </Grid>
        );
    }
}

FormBusinessDaysResto.propTypes = {
    restaurant: PropTypes.object.isRequired,
    isSaving: PropTypes.bool.isRequired,
    isSavedRestaurant: PropTypes.bool.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setDefaultTimetableToRestaurant: value => dispatch(setDefaultTimetableToRestaurant(value)),
    setSavedRestaurant: value => dispatch(setSavedRestaurant(value)),
});

const mapStateToProps = state => ({
    restaurant:  getRestaurant(state),
    isSaving: getIsSavingRestaurant(state),
    isSavedRestaurant: getIsSavedRestaurant(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(FormBusinessDaysResto));